import { errorNotifier } from '@/utils/bugsnag';

export function logError(error: Error, metaData?: Record<string, unknown>) {
  errorNotifier.notify(error, metaData);

  console.error(error);
}
